const MOCK_USERS = {
  "owner@aeronpay.in": {
    id: "1",
    name: "AeronPay Owner",
    email: "owner@aeronpay.in",
    role: "owner",
    permissions: ["*"],
  },
  "admin@aeronpay.in": {
    id: "2",
    name: "Org Admin",
    email: "admin@aeronpay.in",
    role: "super_admin",
    orgId: "org1",
    permissions: ["*"],
  },
  "hr@aeronpay.in": {
    id: "3",
    name: "HR User",
    email: "hr@aeronpay.in",
    role: "hr",
    orgId: "org1",
    permissions: [
      "employees.view",
      "employees.edit",
      "attendance.manage",
      "leave.manage",
      "payroll.manage",
      "recruitment.manage",
      "performance.manage",
    ],
  },
  "manager@aeronpay.in": {
    id: "4",
    name: "Team Manager",
    email: "manager@aeronpay.in",
    role: "manager",
    orgId: "org1",
    permissions: ["team.view", "approvals.manage", "performance.view"],
  },
  "employee@aeronpay.in": {
    id: "5",
    name: "John Employee",
    email: "employee@aeronpay.in",
    role: "employee",
    orgId: "org1",
    permissions: ["self.view", "leave.request", "documents.view"],
  },
};

export function checkIdentifierExists(identifier) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(!!MOCK_USERS[identifier.toLowerCase()]), 500);
  });
}

export function mockLogin(email, password) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const user = MOCK_USERS[email];
      if (user && password === "password123") {
        resolve({ user, token: `mock-token-${user.role}` });
      } else {
        reject(new Error("Incorrect password. Try again."));
      }
    }, 600);
  });
}

export const ROLE_DASHBOARD_MAP = {
  owner: "/owner/dashboard",
  super_admin: "/admin/dashboard",
  hr: "/hr/dashboard",
  manager: "/manager/dashboard",
  employee: "/employee/dashboard",
};
